import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { isUserAllowtoView } from '../../../auth/authUtil';
import { settingRoutes } from '../../omegaRoutes/SettingRoutes';

export default function Settings() {
    const [settings, setSettings] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        let filterSettingRoutes = settingRoutes.filter(route => (
            isUserAllowtoView(route.permissions)
        ))
        setSettings(filterSettingRoutes);
        if (filterSettingRoutes?.length > 0 && location.pathname === "/settings") {
            navigate(filterSettingRoutes[0].path);
        }
    }, [location, navigate])

    const handleTabChange = (index) => {
        const route = settings[index];
        navigate(route.path);
    };

    const findActiveTab = () => {
        if (location.pathname === "/settings")
            return 0;
        else
            return settings.findIndex(item => item["path"] == location.pathname);
    }

    return (
        <div className="card settings">
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2>Settings</h2>
                </Typography>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>
            <TabView activeIndex={findActiveTab()} onTabChange={(event) => handleTabChange(event.index)}>
                {
                    settings.map(route => (
                        <TabPanel key={route.name} header={route.name}>
                            <Outlet />
                        </TabPanel>
                    ))
                }
            </TabView>
        </div >
    )
}
